<template>
  <div>
    <div class='h-toolbarBg'>
      <ejs-toolbar>
        <e-items>
          <e-item prefixIcon='icon hero-icon hero-icon-save' :tooltipText='$ts("Track.download")' :click='buttonClk' operate='download'></e-item>
          <e-item prefixIcon='icon hero-icon hero-icon-download' :tooltipText='$ts("Track.downloadExcel")' :click='buttonClk' operate='downloadExcel'></e-item>
          <e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$ts("Track.delete")' :click='buttonClk' operate='delete'></e-item>
        </e-items>
      </ejs-toolbar>
      <div class='h-inputBox'>
        <ejs-textbox v-model='queryConditions.keywords' :placeholder='$ts("Track.pleaseEnterQuery")' @keydown.native='keydownFunc'></ejs-textbox>
      </div>
    </div>
    <div class='h100vh-180 h-scroll noPage'>
      <ejs-grid ref='grid' height='calc(100% - 0px)' :dataSource='data' :selectionSettings='selectionOptions' :commandClick='commandClickFunc' :allowReordering='true' :allowResizing='true'>
        <e-columns>
          <e-column type='checkbox' minWidth='10' textAlign='Center' width='66'></e-column>
          <e-column field='fileName' minWidth='10' :headerText='$ts("Track.fileName")' textAlign='Center' width='22%' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='neName' minWidth='10' :headerText='$ts("Track.resourceName")' textAlign='Center' width='22%' clipMode='EllipsisWithTooltip' :formatter='neNameFormat'></e-column>
          <e-column field='taskName' minWidth='10' :headerText='$ts("Track.taskName")' textAlign='Center' width='22%' clipMode='EllipsisWithTooltip' :formatter='taskNameFormat'></e-column>
          <e-column field='createTime' minWidth='10' :headerText='$ts("Track.time")' textAlign='Center' width='22%' type='date' :format='dateFormatOptions' clipMode='EllipsisWithTooltip'></e-column>
          <e-column :headerText='$ts("Track.operating")' textAlign='Center' width='12%' :commands='commands' :visible="detailFlag"></e-column>
        </e-columns>
      </ejs-grid>
    </div>
    <iframe src='' style='display: none;' id='downloadAction'></iframe>
  </div>
</template>
<script>
import { Reorder, Resize, CommandColumn } from '@syncfusion/ej2-vue-grids';
import bus from '../bus.js';
import { EventBus } from '../../../plugins/eventBus';
import i18n from '../../../plugins/i18n.js';

export default {
  name: 'DownloadFile',
  data() {
    return {
      detailFlag: true,
      selectionOptions: { type: 'Multiple' },
      dateFormatOptions: { type: 'date', format: 'yyyy-MM-dd HH:mm:ss' },
      commands: [{ title: this.$ts("Track.detail"), buttonOption: { content: ' ', cssClass: 'h-btn-refresh e-btn e-tbar-btn icon hero-icon hero-icon-details' } }],
      data: [],
      primaryDatas: [],
      paramsData: [],
      queryConditions: {
        keywords: '', // 模糊查询关键字
      }
    };
  },
  provide: {
    grid: [Reorder, Resize, CommandColumn]
  },
  methods: {
    $ts(args) {
      const mes = args.split('.');
      const result = (mes[0] && mes[1] && i18n.messages[i18n.locale][mes[0]][mes[1]]) ? i18n.messages[i18n.locale][mes[0]][mes[1]] : args;
      return result;
    },
    neNameFormat() {
      return this.paramsData ? this.paramsData[0].neName : '';
    },
    taskNameFormat() {
      return this.paramsData ? this.paramsData[0].taskName : '';
    },
    keydownFunc(clickEvent) {
      if (clickEvent.keyCode === 13) {
        if (this.queryConditions.keywords === '') {
          this.data = this.primaryDatas;
          return;
        }
        const fileDatas = this.primaryDatas.filter(fileDate => (fileDate.fileName.includes(this.queryConditions.keywords)));
        this.data = fileDatas;
      }
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: `${this.$ts('Alarm.no_checked')}`});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: `${this.$ts('Alarm.too_many_checked')}!`});
        return false;
      }
      return selectedRecords;
    },
    loadFileData(args) {
      this.$axios.get(`/lte/ems/track/queryTaskLoadFiles/${args[0].taskId}`).then((response) => {
        if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
          this.data = response.data.resultVal;
          this.primaryDatas = response.data.resultVal;
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
      });
    },
    buttonClk(args) {
      switch (args.item.operate) {
        case 'download':
          this.downloadFunc();
          break;
        case 'downloadExcel':
          this.downloadExcelFunc();
          break;
        case 'delete':
          this.deleteFunc();
          break;
        default:
      }
    },
    commandClickFunc(args) {
      args.rowData.displaySoftwareVersion = this.paramsData[0].displaySoftwareVersion;
      args.rowData.oamTypeCode = this.paramsData[0].oamTypeCode;
      args.rowData.typeId = this.paramsData[0].typeId;
      bus.$emit('downloadTableTab', [args.rowData]);
      args.cancel = true;
    },
    downloadFunc() {
      const downloadData = this.getCheckedData(true);
      if (downloadData) {
        let params = '';
        for (let i = 0; i < downloadData.length; i++) {
          params += params === '' ? '' : ',';
          params += `${downloadData[i].directoryName}/${downloadData[i].fileName}`;
        }
        const dom = document.getElementById('downloadAction');
        dom.src = `/lte/ems/track/downloadTaskFiles?fileNamesStr=${params}`;
      }
    },
    downloadExcelFunc() {
      const downloadData = this.getCheckedData(true);
      if (downloadData) {
        let params = '';
        for (let i = 0; i < downloadData.length; i++) {
          params += params === '' ? '' : ',';
          params += `${downloadData[i].directoryName}/${downloadData[i].fileName}`;
        }
        const dom = document.getElementById('downloadAction');
        dom.src = `/lte/ems/track/downloadTaskExcelFiles?fileNamesStr=${params}`;
      }
    },
    deleteFunc() {
      const This = this;
      // 删除方法
      const downloadData = this.getCheckedData(true);
      if (downloadData) {
        const params = [];
        for (let i = 0; i < downloadData.length; i++) {
          params.push(`${downloadData[i].directoryName}/${downloadData[i].fileName}`);
        }
        this.$layer.confirm({
          msg: This.$ts('Track.deleteFile'),
          btn1: { msg: This.$ts('Track.cancel') },
          btn2: {
            msg: This.$ts('Track.confirm'),
            func: () => {
              This.$axios.post('/lte/ems/track/deleteTaskFiles', params).then((response) => {
                if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
                  EventBus.$emit('toast', {type: 'success', content: This.$ts('Track.success')});
                  This.loadFileData(this.paramsData);
                } else {
                  EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
                }
              });
            }
          }
        });

      }
    }
  },
  mounted() {
    bus.$on(this.$ts('Track.download'), (args) => {
      if (args[0].fileType === "pcap") {
        this.detailFlag = false;
      }
      this.paramsData = args;
      this.loadFileData(args);
    });
  },
  beforeDestroy() {
    bus.$off(this.$ts('Track.download'));
  }
};
</script>
